export const notEmail = value =>
	value.match(
		/^([\w!#$%&'*+\-/=?^`{|}~]+\.)*[\w!#$%&'*+\-/=?^`{|}~]+@((((([a-z0-9]{1}[a-z0-9-]{0,62}[a-z0-9]{1})|[a-z])\.)+[a-z]{2,6})|(\d{1,3}\.){3}\d{1,3}(:\d{1,5})?)$/i,
	)
		? -30
		: 10;

export const inputLength = value => (value.length >= 6 ? 10 : 0);

export const inputLowercase = value => (value.match(/[a-z]/) ? 10 : 0);

export const inputLowercaseMulti = value =>
	value.match(/(.*[a-z].*[a-z].*[a-z])/) ? 10 : 0;

export const inputUppercase = value => (value.match(/[A-Z]/) ? 10 : 0);

export const inputUppercaseMulti = value =>
	value.match(/(.*[A-Z].*[A-Z])/) ? 10 : 0;

export const inputNumber = value => (value.match(/[0-9]/) ? 10 : 0);

export const inputNumberMulti = value =>
	value.match(/(.*[0-9].*[0-9].*[0-9])/) ? 10 : 0;

export const inputSpecial = value =>
	value.match(/[!,@,#,$,%,^,&,*,?,_,~]/) ? 10 : 0;
